import { getWindowWidth } from "./layout";
/**
 * Global Resize Listener Service
 * This service allows components to subscribe to window resize events.
 * When the window is resized, all subscribed components will be notified.
 * Benefit: Only one resize listener is created for the entire application.
 */
export class ResizeListener {
    constructor(debounceTime = 100) {
        this.callbacks = [];
        this.debounceTime = debounceTime;
        window.addEventListener('resize', this.onResize.bind(this));
    }
    static getInstance() {
        if (!ResizeListener.instance) {
            ResizeListener.instance = new ResizeListener();
        }
        return ResizeListener.instance;
    }
    subscribe(callback) {
        this.callbacks.push(callback);
        // Call the callback immediately with the current size
        callback(this.getCurrentSize());
    }
    unsubscribe(callback) {
        this.callbacks = this.callbacks.filter(cb => cb !== callback);
    }
    onResize() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(() => {
            const size = this.getCurrentSize();
            this.callbacks.forEach(callback => callback(size));
        }, this.debounceTime);
    }
    getCurrentSize() {
        return { windowWidth: getWindowWidth() };
    }
}
//# sourceMappingURL=resizeListener.js.map
